<div *ngIf="title" class="logo"><img *ngIf="type" src="assets/img/journey/setting.svg" alt="icon"></div>
<img *ngIf="!title" class="responsive" src="assets/img/journey/setting.svg" alt="icon" >
<div class="text" *ngIf="title">{{title}}</div>
<div class="status" [ngClass]="{completed: completed && passed, failed: completed && !passed}"></div>
